"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const requestNotificationPermission = async () => {
  try {
    const permissionResult = await Notification.requestPermission();
    if (permissionResult !== "granted") {
      return;
    }
    return permissionResult;
  } catch (error) {
    console.error("notification permission error:", error);
  }
};
var _default = exports.default = requestNotificationPermission;